export default __webpack_public_path__ + "static/media/digital4.d6cbafc6.jpg";